/* ============================================================
   NORTHSHEEP — Variant swatch hover preview on product cards
   Hovering a variant thumbnail swaps the card's MAIN image to that
   variant's image (live colour preview); leaving restores the original.
   The thumbnail link itself (click -> product page with that variant)
   needs no JS. Event-delegated so it survives re-rendered cards
   (recently viewed, AJAX). Only active when the swap setting is on
   (data-swap="1" on the container).
   ============================================================ */
(function () {
  if (window.__nsSwatchLoaded) return;
  window.__nsSwatchLoaded = true;

  function mainImage(swatch) {
    var card = swatch.closest('.card-wrapper') || swatch.closest('.card');
    if (!card) return null;
    return card.querySelector('.card__media img, .card__inner .media img, .card__media .media img');
  }

  function swapEnabled(swatch) {
    var cont = swatch.closest('[data-ns-card-swatches]');
    return cont && cont.getAttribute('data-swap') === '1';
  }

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest && e.target.closest('[data-ns-swatch]');
    if (!swatch || !swapEnabled(swatch)) return;
    var img = mainImage(swatch);
    if (!img) return;
    if (!img.hasAttribute('data-ns-orig-src')) {
      /* currentSrc as the fallback: an image that carries only a srcset has
         no src attribute to remember, and storing "" there meant the restore
         below blanked it — which is how tapping a swatch on a phone, opening
         the product and coming back left a broken-image mark on the card.
         A touch tap fires mouseover, so phones take this path too. */
      var origSrc = img.getAttribute('src') || img.currentSrc || '';
      if (!origSrc) return;
      img.setAttribute('data-ns-orig-src', origSrc);
      img.setAttribute('data-ns-orig-srcset', img.getAttribute('srcset') || '');
    }
    var src = swatch.getAttribute('data-variant-img');
    if (src) {
      img.removeAttribute('srcset');
      img.src = src;
    }
  });

  document.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest && e.target.closest('[data-ns-swatch]');
    if (!swatch || !swapEnabled(swatch)) return;
    // Ignore moves that stay inside the same swatch.
    if (e.relatedTarget && swatch.contains(e.relatedTarget)) return;
    var img = mainImage(swatch);
    if (!img) return;
    // Moving straight to another swatch on the SAME card -> let its mouseover swap.
    var nextSwatch =
      e.relatedTarget && e.relatedTarget.closest ? e.relatedTarget.closest('[data-ns-swatch]') : null;
    if (nextSwatch && mainImage(nextSwatch) === img) return;
    restoreImage(img);
  });

  function restoreImage(img) {
    if (!img || !img.hasAttribute('data-ns-orig-src')) return;
    var src = img.getAttribute('data-ns-orig-src');
    if (!src) return; // never blank an image we cannot put back
    var orig = img.getAttribute('data-ns-orig-srcset');
    if (orig) img.setAttribute('srcset', orig);
    else img.removeAttribute('srcset');
    img.src = src;
  }

  /* Coming BACK to the page. A tap counts as a hover, so a phone leaves the
     card showing the variant's picture; the browser then restores the page
     from its cache exactly as it was, mid-swap. Put every card back. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var imgs = document.querySelectorAll('img[data-ns-orig-src]');
    for (var i = 0; i < imgs.length; i++) restoreImage(imgs[i]);
  });

  /* ---- Auto-fit ----------------------------------------------------------
     Show as many thumbnails as physically fit the card, then a "+N" for the
     rest. Only runs on containers that opt in with data-total (the standard
     product cards) — recently-viewed keeps its own fixed count. */
  var observer = null;

  /* The widest gap allowed when evening out a row — an absolute ceiling, not
     an amount added, or a theme already set to 13px would reach 21px on a
     phone, where a row is two squares and a "+6" and they stop reading as one
     set. A row whose own gap is wider than this keeps its own. */
  var MAX_GAP = 16;

  /* READ EVERYTHING, THEN WRITE EVERYTHING.

     This used to fit one row at a time: reset it, measure it, style it, move
     on. Every measurement after a style write forces the browser to lay the
     page out again first, so a 48-card page paid for 48 synchronous layouts
     (96 after a lazy batch) on every pass.

     Now each step runs for ALL rows before the next step starts — reset every
     row, measure every row, pin every inline row, measure every thumbnail,
     then style every row. Per row it is the same sequence as before, in the
     same order, so the result is identical; the page just gets laid out twice
     per pass instead of twice per card.

     `force` is false only for passes started by the grid observer. Those skip
     rows that were already fitted at their current width: a curate drag
     re-inserts the same cards every frame, and refitting an unchanged row
     reproduces exactly what it already shows. New cards (sort, filter, lazy
     batch) are new elements with no remembered width, so they are always
     fitted. Resizes and outside callers always refit everything. */
  function fitRows(conts, force) {
    var rows = [];
    var i, row;

    // 1. Collect, and on observer passes drop rows already fitted at this width.
    for (i = 0; i < conts.length; i++) {
      var container = conts[i];
      var total = parseInt(container.getAttribute('data-total'), 10) || 0;
      if (!total) continue;
      var imgs = Array.prototype.slice.call(
        container.querySelectorAll('.ns-card-swatch:not(.ns-card-swatch--more)')
      );
      if (!imgs.length) continue;
      var inline = container.classList.contains('ns-card-swatches--info');
      /* In the card's text the row is in the flow, and it must be measured
         against the CARD — not against its own parent. A nowrap row is as wide
         as its contents, which becomes the text column's minimum width, so the
         column reports the width the row already took and every count "fits".
         That feedback loop is what pushed seven thumbnails past the card edge. */
      var box = inline
        ? container.closest('.card-wrapper') || container.closest('.card') || container.parentElement
        : container.closest('.card__inner') || container.closest('.card__media') || container.parentElement;
      if (!box) continue;
      if (!force && container.__nsFitW && box.clientWidth === container.__nsFitW) continue;
      rows.push({
        el: container,
        total: total,
        max: parseInt(container.getAttribute('data-max'), 10) || total,
        url: container.getAttribute('data-url') || '#',
        imgs: imgs,
        inline: inline,
        box: box,
        ok: true,
      });
    }
    if (!rows.length) return;

    // 2. Write: clean slate before measuring.
    for (i = 0; i < rows.length; i++) {
      row = rows[i];
      var oldMore = row.el.querySelector('.ns-card-swatch--more');
      if (oldMore && oldMore.parentNode) oldMore.parentNode.removeChild(oldMore);
      for (var r = 0; r < row.imgs.length; r++) row.imgs[r].style.display = '';
      /* The gap and width this fitter wrote last time go too (audit, 2 Oct
         2026). Step 3 reads the gap back from the computed style, so a refit —
         after Enlarge, a phone rotation or a colour swap — read the gap the
         last pass had widened, and a "3 + 2" row came back as "2 + 3". */
      if (row.inline) {
        row.el.style.columnGap = '';
        row.el.style.maxWidth = '';
      }
    }

    // 3. Read: the available width, the inset and the gap.
    for (i = 0; i < rows.length; i++) {
      row = rows[i];
      var cs = getComputedStyle(row.el);
      row.left = 0;
      if (row.inline) {
        row.boxW = row.box.clientWidth;
        if (!row.boxW) {
          row.ok = false;
          continue;
        }
        /* Measuring the card and subtracting the row's own left inset TWICE
           also gives the gutter on the right that the left side has, so the
           row is always evenly inset and drops to "+N" one thumbnail earlier
           instead of touching the edge. */
        var inset = Math.max(
          0,
          Math.round(row.el.getBoundingClientRect().left - row.box.getBoundingClientRect().left)
        );
        row.avail = row.boxW - inset * 2;
      } else {
        row.boxW = row.avail = row.box.clientWidth;
        row.left = parseFloat(cs.left) || 0;
      }
      // Read now, as a number: the declaration object is live.
      row.gap = parseFloat(cs.columnGap || cs.gap) || 0;
    }

    /* 4. Write: the text column's own padding is not symmetrical (Dawn's card
       pads more on the left than the right), so the row is capped at the even
       box that was just measured. Otherwise "space-between" would stretch it
       to the column's edge and undo the even inset. */
    for (i = 0; i < rows.length; i++) {
      row = rows[i];
      if (!row.ok) continue;
      if (row.inline) row.el.style.maxWidth = row.avail + 'px';
      if (!row.avail || row.avail < 0) row.ok = false;
    }

    // 5. Read: one thumbnail's width, with the row already capped.
    for (i = 0; i < rows.length; i++) {
      row = rows[i];
      if (!row.ok) continue;
      row.itemW = row.imgs[0].offsetWidth;
      if (!row.itemW) row.ok = false;
    }

    // 6. Write: show what fits, add the "+N", share out the gap.
    for (i = 0; i < rows.length; i++) {
      row = rows[i];
      if (!row.ok) continue;
      var gap = row.gap;
      var itemW = row.itemW;

      // Over the picture the row is inset from the left only, so its own `left`
      // comes off the width. Inline it is already even on both sides.
      var avail = row.inline ? row.avail : row.avail - row.left - 6;
      var fit = Math.floor((avail + gap) / (itemW + gap));
      if (fit < 1) fit = 1;

      var slots = Math.min(row.max, fit, row.imgs.length); // never show more than rendered
      var showImgs = row.total <= slots ? Math.min(row.total, row.imgs.length) : Math.max(1, slots - 1);

      for (var k = 0; k < row.imgs.length; k++) {
        row.imgs[k].style.display = k < showImgs ? '' : 'none';
      }

      var hidden = row.total - showImgs;
      if (hidden > 0) {
        var a = document.createElement('a');
        a.className = 'ns-card-swatch ns-card-swatch--more';
        a.href = row.url;
        a.setAttribute('aria-label', hidden + ' more variants');
        a.textContent = '+' + hidden;
        row.el.appendChild(a);
      }

      /* Inline, the leftover is shared between the thumbnails so the row does
         not stop well short of the text's right edge — but only up to a point.
         Left to spread freely (justify-content: space-between did exactly this),
         a phone card with two thumbnails and a "+6" put twenty pixels of air
         between them and read as three unrelated squares. Capped, the row stays
         a row: nearly even at the ends on a wide card, still tight on a narrow
         one. The width is then pinned so nothing stretches it further. */
      if (row.inline) {
        var count = showImgs + (hidden > 0 ? 1 : 0);
        var rowGap = gap;
        if (count > 1) {
          var slack = avail - (count * itemW + (count - 1) * gap);
          if (slack > 0) rowGap = Math.min(gap + slack / (count - 1), Math.max(gap, MAX_GAP));
        }
        row.el.style.columnGap = rowGap + 'px';
        row.el.style.maxWidth = count * itemW + (count - 1) * rowGap + 'px';
      }

      // Remembered so an observer pass can tell this row is already right.
      row.el.__nsFitW = row.boxW;
    }
  }

  function fit(force) {
    if (observer) observer.disconnect();
    fitRows(document.querySelectorAll('[data-ns-card-swatches][data-total]'), force);
    reconnect();
  }

  function fitAll() {
    fit(true);
  }

  /* THE CONTAINER, NOT ONLY THE GRID (audit, 23 Sep 2026). Sorting and
     filtering replace #ProductGridContainer's innerHTML wholesale, so a
     .product-grid watched here is destroyed with it and the new cards were
     never fitted — four thumbnails and no "+N" for the rest of the visit.
     ns-card-size-pills.js already fixed this exact trap; same roots here. */
  function reconnect() {
    if (!observer) return;
    var roots = document.querySelectorAll('#ProductGridContainer, .product-grid, product-recommendations, .ns-srow__track, .ns-product-related');
    for (var i = 0; i < roots.length; i++) observer.observe(roots[i], { childList: true, subtree: true });
  }

  /* Still one debounced pass. A resize anywhere in the burst makes the whole
     pass a full refit, since every row's width may have moved. */
  var fitTimer = null;
  var fitForce = false;
  function scheduleFit(force) {
    if (force) fitForce = true;
    window.clearTimeout(fitTimer);
    fitTimer = window.setTimeout(function () {
      /* A card is being held and dragged: the grid changes each time it passes
         a neighbour, but no row changes width. Refit once it is dropped, not
         mid-gesture (it was felt as a hitch after each crossing). */
      if (document.body.classList.contains('ns-fav-sorting')) { scheduleFit(false); return; }
      var f = fitForce;
      fitForce = false;
      fit(f);
    }, 80);
  }

  function initFit() {
    if ('MutationObserver' in window) {
      observer = new MutationObserver(function () {
        scheduleFit(false);
      });
    }
    fitAll();
    /* WIDTH CHANGES ONLY. A phone's browser toolbar collapsing or coming back
       fires `resize` with only the HEIGHT changed — at the start of almost
       every scroll — and each one refitted every card, a full-grid layout in
       the middle of the gesture. No row's width can change unless the
       window's width does. */
    var lastW = window.innerWidth;
    window.addEventListener(
      'resize',
      function () {
        if (window.innerWidth === lastW) return;
        lastW = window.innerWidth;
        scheduleFit(true);
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFit);
  } else {
    initFit();
  }
  window.nsFitSwatches = fitAll; // exposed so other scripts can re-fit if needed
})();
